(function (angular) {
  "use strict";

  angular.module("Toyota.Directives").directive("tyBodyPaintRepair", function () {
    var controller = [
      "$scope",
      "$analytics",
      "$attrs",
      "$location",
      function ($scope, $analytics, $attrs, $location) {
        var ctl = this;

        function init() {
          $scope.bodyPaintRepair = {
            repairers: JSON.parse($attrs.repairers),
            page: 1,
            pageSize: 6,
            state: null,
            results: [],
          };

          $scope.$watch("bodyPaintRepair.state", function (newValue, oldValue) {
            if (newValue !== oldValue) {
              resetPaging();

              $location.search({
                state: newValue,
              });

              if (newValue) {
                ctl.track("State Selected - " + newValue);
              }
            }
          });

          $scope.$on("$locationChangeSuccess", function () {
            var query = $location.search();
            var state = normaliseState(query.state);

            if (state) {
              $scope.bodyPaintRepair.state = state;
              ctl.showResults();
            }
          });
        }

        ctl.hasResults = function () {
          return $scope.bodyPaintRepair.results.length > 0;
        };

        ctl.getStates = function () {
          return $scope.bodyPaintRepair.repairers.map(function (state) {
            return state.Name;
          });
        };

        ctl.getTotalResults = function () {
          return getBodyPaintRepairers().length;
        };

        ctl.nextPage = function () {
          $scope.bodyPaintRepair.page++;
          ctl.showResults();
        };

        ctl.showResults = function () {
          $scope.bodyPaintRepair.results = getBodyPaintRepairers().filter(function (state, i) {
            return i < getCurrentResultsSize();
          });
        };

        ctl.isLastPage = function () {
          return getCurrentResultsSize() === ctl.getTotalResults();
        };

        ctl.track = function (label, action) {
          var props = {
            event: "gaClick",
            eventCategory: "Accident & Repairs",
            eventAction: action || "Body & Paint Repair",
            eventLabel: label,
          };

          $analytics.eventTrack("gaClick", props);
        };

        function getBodyPaintRepairers() {
          return $scope.bodyPaintRepair.repairers.reduce(function (base, state) {
            if (state.Name === normaliseState($scope.bodyPaintRepair.state)) {
              return state.BodyPaintRepairers;
            }

            return base;
          }, []);
        }

        function getCurrentResultsSize() {
          var resultsCeiling = $scope.bodyPaintRepair.page * $scope.bodyPaintRepair.pageSize;
          var resultsSize = getBodyPaintRepairers().length;

          return resultsCeiling > resultsSize ? resultsSize : resultsCeiling;
        }

        function normaliseState(stateParam) {
          return ctl.getStates().find(function (state) {
            return stateParam && state.toLowerCase() === stateParam.toLowerCase();
          });
        }

        function resetPaging() {
          $scope.bodyPaintRepair.page = 1;
        }

        this.$onInit = init;
      },
    ];

    return {
      scope: false,
      restrict: "A",
      controller: controller,
      controllerAs: "bodyPaintRepairController",
    };
  });
})(window.angular);
